import { ArrowRight, Play, Quote, ShieldCheck, UserCheck, Lightbulb, Users, Smile, Heart, Leaf, Award, Calendar } from 'lucide-react';
import { motion } from 'framer-motion';


function SobreNos() {
  const purpleColor = '#8B5CF6'; // Purple accent color

  return (
    <div className="bg-white min-h-screen font-sans text-gray-900">

      {/* Hero Section - Light Corporate Style (White) */}
      <section className="relative h-[650px] md:h-[800px] flex items-center overflow-hidden bg-white">
        {/* Background Image with Light Overlay */}
        <div className="absolute inset-0 z-0">
          <motion.img
            initial={{ scale: 1.1, opacity: 0 }}
            animate={{ scale: 1, opacity: 0.15 }}
            transition={{ duration: 2, ease: "easeOut" }}
            src="/assets/training/workshop_neutral.png"
            alt="Workshop Remoto Lukos"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-linear-to-r from-white via-white/80 to-transparent"></div>
          <div className="absolute inset-0 bg-linear-to-b from-transparent via-transparent to-white"></div>
        </div>

        <div className="container mx-auto px-4 relative z-10 pt-20 flex items-center justify-center">
          <div className="max-w-4xl">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              <span className="inline-block text-[#8B5CF6] font-bold tracking-[0.3em] uppercase mb-6 text-sm md:text-base px-4 py-2 border border-[#8B5CF6]/30 rounded-full bg-[#8B5CF6]/5">
                Sobre Nós
              </span>
            </motion.div>

            <motion.h1
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
              className="text-7xl md:text-9xl font-black text-gray-900 uppercase leading-[0.9] mb-8 tracking-tighter"
            >
              LUKOS <br />
              <span className="text-transparent bg-clip-text bg-linear-to-r from-[#8B5CF6] via-purple-500 to-indigo-600 drop-shadow-sm">
                TECNOLOGIA
              </span>
            </motion.h1>

            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.6 }}
              className="relative"
            >
              <p className="text-gray-600 text-lg md:text-xl leading-relaxed font-medium max-w-2xl bg-white/50 backdrop-blur-sm rounded-2xl p-6 border border-white/60 shadow-sm">
                Com mais de <span className="text-[#8B5CF6] font-bold">10 anos de experiência</span>, somos especialistas em desenvolver soluções tecnológicas que transformam a gestão de <span className="text-gray-900 font-bold">postos de combustíveis</span> e varejo. Nossa missão é entregar eficiência, segurança e inovação para o seu negócio crescer.
              </p>
            </motion.div>


          </div>
        </div>
      </section>

      {/* Overview Section - Brand Purple Background */}
      <section className="py-24 bg-[#8B5CF6] relative overflow-hidden">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">

            {/* Text Content */}
            <div className="relative z-10">
              <span className="text-purple-200 text-sm uppercase tracking-widest font-bold mb-2 block border-l-2 border-white pl-3">
                Visão Geral
              </span>
              <h2 className="text-4xl md:text-5xl font-black text-white uppercase mb-8 leading-tight tracking-tighter">
                PRONTOS PARA <br />
                <span className="text-purple-200">O FUTURO</span>
              </h2>

              <div className="space-y-6 text-white/90 leading-relaxed font-light">
                <div>
                  <span className="block text-white font-bold uppercase tracking-widest text-sm mb-2">Nossa Visão</span>
                  <p>
                    Ser a principal referência no desenvolvimento de software para Postos de Combustíveis e Varejo, liderando a transformação digital do setor e promovendo o crescimento sustentável e o bem-estar de nossos clientes, parceiros, colaboradores e da comunidade.
                  </p>
                </div>
              </div>
            </div>

            {/* Video Content */}
            <div className="relative group">
              <div className="aspect-video bg-white rounded-3xl overflow-hidden shadow-2xl relative border border-white/20 group-hover:border-white/40 transition-all duration-500">
                <iframe
                  className="w-full h-full opacity-90 group-hover:opacity-100 transition-opacity"
                  src="https://www.youtube.com/embed/F_itCCQd0nk"
                  title="Vídeo Institucional"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
              <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-white -z-10 opacity-10 blur-3xl"></div>
            </div>

          </div>
        </div>
      </section>

      {/* Testimonials Section - White Background */}
      <section className="py-24 relative bg-white overflow-hidden">
        <div className="container mx-auto px-4 relative z-10">
          <div className="text-center mb-16">
            <span className="text-gray-500 text-xs uppercase tracking-[0.3em] block mb-2">
              Histórias de Sucesso
            </span>
            <h2 className="text-4xl md:text-5xl font-black text-gray-900 uppercase tracking-tighter">
              A LUKOS APLICADA <br />
              <span className="text-[#8B5CF6]">AO SEU NEGÓCIO</span>
            </h2>
            <div className="w-16 h-1.5 bg-[#8B5CF6] mx-auto mt-6 rounded-full"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            <div className="aspect-video rounded-3xl overflow-hidden shadow-xl border border-gray-100">
              <iframe
                className="w-full h-full"
                src="https://www.youtube.com/embed/sjWk3XpdH3s"
                title="Depoimento 1"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>

            <div className="aspect-video rounded-3xl overflow-hidden shadow-xl border border-gray-100">
              <iframe
                className="w-full h-full"
                src="https://www.youtube.com/embed/diPZayPotMU"
                title="Depoimento 4"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section - Brand Purple Background */}
      <section className="py-24 bg-[#8B5CF6] relative overflow-hidden">
        <div className="container mx-auto px-4 text-center relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <span className="text-purple-200 text-xs uppercase tracking-widest mb-2 block font-semibold">
              Nossa Cultura
            </span>
            <h2 className="text-4xl md:text-5xl font-black text-white uppercase mb-20 tracking-tight">
              NOSSOS VALORES
            </h2>
          </motion.div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 justify-center items-start max-w-6xl mx-auto">

            {/* Value Items Data */}
            {[
              { icon: ShieldCheck, title: "Respeito e Confiança" },
              { icon: UserCheck, title: "Cliente em Primeiro Lugar" },
              { icon: Lightbulb, title: "Inovação Constante" },
              { icon: Users, title: "Trabalho em Equipe" },
              { icon: Smile, title: "Ambiente Valorizado" },
              { icon: Heart, title: "Paixão pelo que Fazemos" },
              { icon: Leaf, title: "Sustentabilidade" }
            ].map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="flex flex-col items-center gap-4 group"
              >
                <motion.div
                  whileHover={{ scale: 1.1, rotate: 5 }}
                  className="w-24 h-24 bg-white/10 backdrop-blur-sm rounded-3xl flex items-center justify-center group-hover:bg-white transition-all duration-300 border border-white/20 shadow-lg group-hover:shadow-purple-900/50"
                >
                  <item.icon className="w-10 h-10 text-white group-hover:text-[#8B5CF6] transition-colors duration-300" />
                </motion.div>
                <span className="text-white font-bold uppercase tracking-wide text-xs md:text-sm max-w-[150px] leading-tight opacity-90 group-hover:opacity-100 transition-opacity">
                  {item.title}
                </span>
              </motion.div>
            ))}

          </div>
        </div>

        {/* Background Decorative Elements */}
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-20">
          <div className="absolute -top-24 -left-24 w-96 h-96 bg-purple-400 rounded-full blur-3xl mix-blend-overlay animate-pulse"></div>
          <div className="absolute bottom-0 right-0 w-64 h-64 bg-indigo-500 rounded-full blur-3xl mix-blend-overlay"></div>
        </div>
      </section>

      {/* Events and Workshops Section - White Background */}
      <section className="py-32 bg-white relative border-t border-gray-100">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <span className="text-gray-500 text-xs uppercase tracking-[0.3em] block mb-2">
              Conexões e Aprendizado
            </span>
            <h2 className="text-4xl font-black text-gray-900 uppercase tracking-tight leading-none mb-4">
              EVENTOS E <span className="text-[#8B5CF6]">WORKSHOPS</span>
            </h2>
            <div className="w-16 h-1.5 bg-[#8B5CF6] mx-auto mt-6 rounded-full"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
            {/* ACBR */}
            <div className="group relative overflow-hidden rounded-3xl cursor-pointer shadow-lg border border-gray-200">
              <div className="aspect-4/3 overflow-hidden">
                <img
                  src="https://lukos.com.br/wp-content/uploads/2025/01/IMG_0592.png"
                  alt="ACBR Event"
                  className="w-full h-full object-cover transition-all duration-700 group-hover:scale-110"
                />
              </div>
              <div className="absolute inset-0 bg-linear-to-t from-slate-900 via-transparent to-transparent opacity-60 group-hover:opacity-80 transition-opacity"></div>
              <div className="absolute bottom-0 left-0 p-8">
                <span className="text-[#8B5CF6] text-xs font-bold uppercase tracking-wider mb-2 block">Tecnologia</span>
                <h3 className="text-white text-2xl font-black uppercase mb-1">ACBR</h3>
              </div>
            </div>

            {/* BXBRASIL */}
            <div className="group relative overflow-hidden rounded-3xl cursor-pointer shadow-lg border border-gray-200">
              <div className="aspect-4/3 overflow-hidden">
                <img
                  src="https://lukos.com.br/wp-content/uploads/2025/01/IMG_0676.png"
                  alt="BXBRASIL Event"
                  className="w-full h-full object-cover transition-all duration-700 group-hover:scale-110"
                />
              </div>
              <div className="absolute inset-0 bg-linear-to-t from-slate-900 via-transparent to-transparent opacity-60 group-hover:opacity-80 transition-opacity"></div>
              <div className="absolute bottom-0 left-0 p-8">
                <span className="text-[#8B5CF6] text-xs font-bold uppercase tracking-wider mb-2 block">Business</span>
                <h3 className="text-white text-2xl font-black uppercase mb-1">BXBRASIL</h3>
              </div>
            </div>

            {/* EXPOPOSTOS */}
            <div className="group relative overflow-hidden rounded-3xl cursor-pointer shadow-lg border border-gray-200">
              <div className="aspect-4/3 overflow-hidden">
                <img
                  src="https://lukos.com.br/wp-content/uploads/2025/01/IMG_0839.png"
                  alt="EXPOPOSTOS Event"
                  className="w-full h-full object-cover transition-all duration-700 group-hover:scale-110"
                />
              </div>
              <div className="absolute inset-0 bg-linear-to-t from-slate-900 via-transparent to-transparent opacity-60 group-hover:opacity-80 transition-opacity"></div>
              <div className="absolute bottom-0 left-0 p-8">
                <span className="text-[#8B5CF6] text-xs font-bold uppercase tracking-wider mb-2 block">Setor de Combustíveis</span>
                <h3 className="text-white text-2xl font-black uppercase mb-1">EXPOPOSTOS</h3>
              </div>
            </div>

          </div>
        </div>
        <div className="container mx-auto px-4 pt-16">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            <img src="https://lukos.com.br/wp-content/uploads/2025/01/IMG_0858.png" className="w-full h-48 object-cover rounded-2xl shadow-md hover:scale-105 transition-all duration-500 border border-gray-200" alt="Gallery 1" />
            <img src="https://lukos.com.br/wp-content/uploads/2025/01/IMG_0880.png" className="w-full h-48 object-cover rounded-2xl shadow-md hover:scale-105 transition-all duration-500 border border-gray-200" alt="Gallery 2" />
            <img src="https://lukos.com.br/wp-content/uploads/2025/01/IMG_0971.png" className="w-full h-48 object-cover rounded-2xl shadow-md hover:scale-105 transition-all duration-500 border border-gray-200" alt="Gallery 3" />
            <img src="https://lukos.com.br/wp-content/uploads/2025/01/IMG_1010.png" className="w-full h-48 object-cover rounded-2xl shadow-md hover:scale-105 transition-all duration-500 border border-gray-200" alt="Gallery 4" />
          </div>
        </div>
      </section>
    </div>
  );
}

export default SobreNos;
